import { marketplaceBudgetMin } from '@/utils/marketplaceBudgetLimits';
import type { MissingBaseBudgetCampaign } from '@/types/hourlyBudget';

export function baseBudgetMinimum(
  item: Pick<MissingBaseBudgetCampaign, 'product' | 'schedule'>,
  countryCode: string | null | undefined,
  accountType: string | null | undefined
): number | null {
  const products =
    item.schedule && item.schedule.shared_campaign_count > 1 && item.schedule.products.length > 0
      ? item.schedule.products
      : [item.product];
  const mins = products
    .map((adProduct) =>
      marketplaceBudgetMin({
        countryCode,
        accountType,
        adProduct,
        period: 'daily',
      })
    )
    .filter((value): value is number => value != null);
  if (mins.length === 0) return null;
  return Math.max(...mins);
}

export function formatBudgetMinimum(value: number): string {
  return Number.isInteger(value) ? String(value) : String(value);
}
